module.exports = __webpack_public_path__ + "img/error1.b0c835e1.png";